<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'gridimg',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col  :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <a class="content-box"  :href="item.url" >
              <img :src="addip(item.pic)" :alt="item.name"  class="margin-bottom" style="width: 100%;height:auto;" />
              <h3 >{{ item.name }}</h3>
              <h5 v-if="item.sub">{{ item.sub }}</h5>
            </a>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="gridimg">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
